module.exports = __webpack_public_path__ + "img/busfront2.b2e65d87.png";